/**
 * Type definitions for the trivia application
 */

/**
 * Custom API error interface that extends the standard Error
 * Used for HTTP API errors with additional metadata
 */
export interface ApiError extends Error {
  /** HTTP status code */
  status?: number;
  /** Request ID for tracking */
  requestId?: string;
  /** Whether this is a transient error that might succeed on retry */
  transient?: boolean;
}

/**
 * Query error type for TanStack Query retry logic
 * Can be either a PostgrestError (from Supabase) or an ApiError (from HTTP requests)
 */
export type QueryError = ApiError | Error;

/**
 * Type guard to check if an error has a status property
 */
export function hasStatus(error: QueryError): error is ApiError {
  return 'status' in error && typeof error.status === 'number';
}
